<div class="extractor-report-page">

  <!-- ========================
       PAGE HEADER
       ======================== -->

  <div class="report-page-header">

    <div>

      <button
        type="button"
        class="back-link"
        (click)="backToExtractor()">

        <i class="fas fa-arrow-left"></i>
        Extractor

      </button>

      <h2 class="report-title">
        Extractor Details Report
      </h2>

      <p class="report-subtitle">
        View patients processed through the extractor
        with detailed status and source information.
      </p>

    </div>

  </div>


  <!-- ========================
       FILTER PANEL
       ======================== -->

  <div class="report-panel filter-panel">

    <div class="filter-heading">

      <div class="filter-title">
        <i class="fas fa-filter"></i>
        Filters
      </div>

    </div>


    <div class="filter-grid">

    <!-- Client -->
    <div class="filter-control">

        <label>Client</label>

        <div class="client-scope-toggle">

        <button
            type="button"
            [class.active]="clientScope === 'SINGLE'"
            (click)="setClientScope('SINGLE')">

            Current Client

        </button>

        <button
            type="button"
            [class.active]="clientScope === 'ALL'"
            (click)="setClientScope('ALL')">

            All Clients

        </button>

        </div>

    </div>


    <!-- Status -->
    <div class="filter-control">

        <label>Status</label>

        <select
        class="form-control"
        [(ngModel)]="selectedStatus">

        <option
            *ngFor="let status of extractionStatuses"
            [ngValue]="status">

            {{
            status === 'FAILED'
                ? 'Not Found'
                : status
            }}

        </option>

        </select>

    </div>


    <!-- Insurance -->
    <div class="filter-control">

        <label>Insurance Type</label>

        <mat-select
        class="insurance-multi-select"
        multiple
        [(ngModel)]="selectedSources">

        <mat-select-trigger>

            {{
            selectedSources?.length
                ? getSelectedInsuranceLabel()
                : 'Select Insurance'
            }}

        </mat-select-trigger>

        <mat-option
            *ngFor="let source of extractionSources"
            [value]="source">

            {{ getInsuranceDisplayName(source) }}

        </mat-option>

        </mat-select>

    </div>


    <!-- From Date -->
    <div class="filter-control">

        <label>From Date</label>

        <input
        type="text"
        class="form-control"
        bsDatepicker
        [(ngModel)]="startDate"
        [maxDate]="todaysDate"
        [bsConfig]="{
            dateInputFormat: 'MM-DD-YYYY',
            adaptivePosition: true
        }">

    </div>


    <!-- To Date -->
    <div class="filter-control">

        <label>To Date</label>

        <input
        type="text"
        class="form-control"
        bsDatepicker
        [(ngModel)]="endDate"
        [maxDate]="todaysDate"
        [bsConfig]="{
            dateInputFormat: 'MM-DD-YYYY',
            adaptivePosition: true
        }">

    </div>


    <!-- Actions -->
    <div class="filter-actions">

        <button
        type="button"
        class="btn-reset"
        (click)="resetFilters()">

        Reset

        </button>

        <button
        type="button"
        class="btn-apply"
        [disabled]="isLoading"
        (click)="applyFilters()">

        Apply Filters

        </button>

    </div>

    </div>

  </div>


  <!-- ========================
       KPI SUMMARY
       ======================== -->

  <div class="extraction-report-kpis">

    <!-- TOTAL -->

    <div class="report-kpi report-kpi-total">

      <div class="report-kpi-icon">

        <i class="fas fa-users"></i>

      </div>

      <div>

        <span class="report-kpi-label">
          Total Patients
        </span>

        <strong>
          {{ totalCount }}
        </strong>

      </div>

    </div>


    <!-- SUCCESS -->

    <div class="report-kpi report-kpi-success">

      <div class="report-kpi-icon">

        <i class="fas fa-check"></i>

      </div>

      <div>

        <span class="report-kpi-label">
          Successful
        </span>

        <strong>
          {{ successCount }}
        </strong>

        <small>
          {{ successPercentage | number:'1.1-2' }}%
        </small>

      </div>

    </div>


    <!-- FAILED -->

    <div class="report-kpi report-kpi-failed">

      <div class="report-kpi-icon">

        <i class="fas fa-times"></i>

      </div>

      <div>

        <span class="report-kpi-label">
          Not Found
        </span>

        <strong>
          {{ failedCount }}
        </strong>

        <small>
          {{ failedPercentage | number:'1.1-2' }}%
        </small>

      </div>

    </div>

  </div>


  <!-- ========================
       PATIENT REPORT
       ======================== -->

  <div class="report-panel patient-report-panel">

    <!-- TABLE HEADER -->

    <div class="patient-report-header">

      <div>

        <h4>
          Patient List
        </h4>

        <span class="record-count">

          {{ filteredRecords.length }}
          records

        </span>

      </div>


      <div class="report-search">

        <i class="fas fa-search"></i>

        <input
          type="text"
          placeholder="Search patient, member ID or insurance..."
          [(ngModel)]="searchText"
          (ngModelChange)="applySearch()">

      </div>

    </div>


    <!-- LOADING -->

    <div
      class="report-loading"
      *ngIf="isLoading">

      <i class="fas fa-spinner fa-spin"></i>

      Loading extraction report...

    </div>


    <!-- ERROR -->

    <div
      class="report-empty"
      *ngIf="
        !isLoading &&
        loadError
      ">

      <i class="fas fa-exclamation-circle"></i>

      <span>
        Unable to load extraction report.
      </span>

    </div>


    <!-- EMPTY -->

    <div
      class="report-empty"
      *ngIf="
        !isLoading &&
        !loadError &&
        filteredRecords.length === 0
      ">

      <i class="fas fa-file-alt"></i>

      <span>
        No extraction records found
        for the selected filters.
      </span>

    </div>


    <!-- TABLE -->

    <div
      class="table-responsive"
      *ngIf="
        !isLoading &&
        !loadError &&
        filteredRecords.length > 0
      ">

      <table class="table extraction-report-table">

        <thead>

          <tr>

            <th>
              #
            </th>

            <th>
              Patient Name
            </th>

            <th>
              DOB
            </th>

            <th>
              Member ID
            </th>

            <th>
              Client
            </th>

            <th>
              Office
            </th>

            <th>
              Insurance
            </th>

            <th>
              Status
            </th>

            <th>
              Extracted On
            </th>

          </tr>

        </thead>


        <tbody>

          <tr
            *ngFor="
              let patient of
              paginatedRecords;
              let i = index
            ">

            <td>

              {{
                (
                  currentPage - 1
                ) * pageSize +
                i + 1
              }}

            </td>


            <td class="patient-name">

              {{
                patient.firstName +
                ' ' +
                patient.lastName
              }}

            </td>


            <td>

              {{
                patient.dateOfBirth ||
                '-'
              }}

            </td>


            <td class="member-id">

              {{
                patient.memberId ||
                '-'
              }}

            </td>


            <td>

              {{
                patient.clientId ||
                '-'
              }}

            </td>


            <td>

              {{
                patient.officeId ||
                '-'
              }}

            </td>


            <td>

              {{
                getInsuranceDisplayName(
                  patient.source
                )
              }}

            </td>


            <td>

              <span
                class="status-badge"
                [ngClass]="
                  patient.status === 'SUCCESS'
                    ? 'status-success'
                    : 'status-failed'
                ">

                {{
                  patient.status === 'FAILED'
                    ? 'NOT FOUND'
                    : patient.status
                }}

              </span>

            </td>


            <td>

              {{
                patient.createdAt ||
                '-'
              }}

            </td>

          </tr>

        </tbody>

      </table>

    </div>


    <!-- ========================
         PAGINATION
         ======================== -->

    <div
      class="report-pagination"
      *ngIf="
        !isLoading &&
        filteredRecords.length > 0
      ">

      <div class="pagination-info">

        Showing

        {{
          (
            currentPage - 1
          ) * pageSize + 1
        }}

        to

        {{
          Math.min(
            currentPage *
            pageSize,
            filteredRecords.length
          )
        }}

        of

        {{
          filteredRecords.length
        }}

        records

      </div>


      <div class="pagination-actions">

        <select
          class="page-size-select"
          [(ngModel)]="pageSize"
          (change)="onPageSizeChange()">

          <option
            *ngFor="
              let size of
              pageSizeOptions
            "
            [ngValue]="size">

            {{ size }} per page

          </option>

        </select>


        <button
          type="button"
          class="pagination-btn"
          [disabled]="currentPage === 1"
          (click)="previousPage()">

          <i class="fas fa-chevron-left"></i>

        </button>


        <span class="pagination-page">

          {{ currentPage }}
          /
          {{ totalPages }}

        </span>


        <button
          type="button"
          class="pagination-btn"
          [disabled]="currentPage === totalPages"
          (click)="nextPage()">

          <i class="fas fa-chevron-right"></i>

        </button>

      </div>

    </div>

  </div>

</div>